import React, { useState, useEffect } from "react";

import Card from "./Card";
import Modal from "../Modals/Modal";
import DopInfo from "./Components/DopInfo";
import { AMO_ABORTED_ID, AMO_COMPLETED_ID } from "../../../consts";

const miniStatuses = (order) => {
    let statuses = [{ name: "Принят", date: new Date(order.created_at) }];
    const lastStatusDone = order.statuses.done[order.statuses.done.length - 1];
    const preLastStatusDone = order.statuses.done[order.statuses.done.length - 2];

    if (order.statuses.done.length == 0 && order.statuses.next.length == 0) {
        statuses.push({
            name: "Оформление", date: new Date(order.statuses.created_at),
        }, {
            name: "Доставлено", date: new Date(order.statuses.created_at),
        });
        return {
            statuses,
            done: false,
        };
    }

    if (order.statuses.in_progress) {
        statuses.push({
            name: lastStatusDone.name, date: new Date(lastStatusDone.update_date)
        }, {
            name: order.statuses.in_progress.name, date: new Date(order.statuses.in_progress.update_date)
        });

        return { statuses, done: false };
    }

    statuses.push({
        name: preLastStatusDone.name, date: new Date(preLastStatusDone.update_date)
    }, {
        name: lastStatusDone.name, date: new Date(lastStatusDone.update_date)
    });

    return {
        statuses,
        done: true
    }
}

const Dostavka = ({ data, orderList, navOpen, IsPopoverOpen, setIsPopoverOpen }) => {

    const [filter, setFilter] = useState("all");
    const [cardsData, setCardsData] = useState(orderList);
    const [selectedOrder, setSelectedOrder] = useState(orderList[0]);


    const [isModalOpen, setIsModalOpen] = useState(false);

    const filteredOrders = orderList.filter((order) => {
        const lastDone = order.statuses.done[order.statuses.done.length - 1];
        if (filter === "all") return true;
        if (!lastDone && filter == "in_progress") return true;
        if (filter === "in_progress") return order.statuses.in_progress;
        if (filter === "delivered") return lastDone.amo_id == AMO_COMPLETED_ID;
        if (filter === "aborted") return lastDone.amo_id == AMO_ABORTED_ID;
    });

    console.log(filteredOrders);

    useEffect(() => {
        if (!filteredOrders.includes(selectedOrder)) {
            setSelectedOrder(filteredOrders[0] || null);
        }
    }, [filter, filteredOrders, selectedOrder]);

    //   useEffect(() => {
    //     if (data.card_list.length === 0){
    //         setIsModalOpen(true);
    //         setIsPopoverOpen(true);
    //     }
    //   }, [setIsPopoverOpen])

    const loadCardsData = async () => {
        window.location.reload();
    };

    //   const closeModal = () => {
    //     setIsModalOpen(false);
    //   };

    const isActive = (currentFilter) =>
        filter === currentFilter
            ? "bg-[#E0473F] text-[#FFF]"
            : " hover:bg-[#E0473F] hover:text-[#FFF]";

    return (
        <div className="w-full md:h-[100vh] flex lg:flex-row flex-col hide-scrollbar over overflow-y-auto lg:overflow-y-hidden overflow-x-hidden xs:mr-5 lg:mr-0 "
            style={{
                backgroundColor: '#EFF0F2'
            }}>
            <div className="lg:w-[45%] xs:w-full lg:px-6 lg:pr-5 pt-5 md:px-0 md:pr-0 px-4 xs:h-fit lg:h-full h-full left flex flex-col justify-start items-center xs:mb-0 mb-6">
                <div className="header w-full h-fit mb-5">
                    <div className="text-[32px] title h-fit lg:w-full xs:w-fit xs:gap-4 flex flex-row justify-between mb-6  items-center ">
                        <span>{data.title}</span>
                        <button
                            onClick={loadCardsData}
                        >
                            <img src={data.reload_img} alt="->" />
                        </button>
                    </div>
                    <div className={`buttons h-fit lg:w-full xs:w-fit gap-2 flex flex-row justify-between hide-scrollbar overflow-x-auto `}>
                        <button
                            onClick={() => setFilter("all")}
                            style={{ borderColor: data.border_color }}
                            className={`border-[1px] transition duration-300 hover:bg-[#E0473F] hover:text-[#FFF] active:bg-[#C3372E] px-4 py-2 rounded-full text-[16px] whitespace-nowrap ${isActive(
                                "all"
                            )}`}>
                            {data.button_1}
                        </button>
                        <button
                            onClick={() => setFilter("in_progress")}
                            style={{ borderColor: data.border_color }}
                            className={`border-[1px] transition duration-300 hover:bg-[#E0473F] hover:text-[#FFF] active:bg-[#C3372E] px-4 py-2 rounded-full text-[16px]  whitespace-nowrap ${isActive(
                                "in_progress"
                            )}`}>
                            {data.button_2}
                        </button>
                        <button
                            onClick={() => setFilter("delivered")}
                            style={{ borderColor: data.border_color }}
                            className={`border-[1px] transition duration-300 hover:bg-[#E0473F] hover:text-[#FFF] active:bg-[#C3372E] px-4 py-2 rounded-full text-[16px] whitespace-nowrap ${isActive(
                                "delivered"
                            )}`}>
                            {data.button_3}
                        </button>
                        <button
                            onClick={() => setFilter("aborted")}
                            style={{ borderColor: data.border_color }}
                            className={`border-[1px] transition duration-300 hover:bg-[#E0473F] hover:text-[#FFF] active:bg-[#C3372E] px-4 py-2 rounded-full text-[16px] whitespace-nowrap ${isActive(
                                "aborted"
                            )}`}>
                            {data.button_4}
                        </button>
                    </div>
                </div>
                <div
                    style={{
                        gridTemplateRows: filteredOrders.length === 1 ? "repeat(1, auto)" : "repeat(2, auto)",
                    }}
                    className={`hide-scrollbar cards w-full h-fit grid xs:grid-rows-2 ${filteredOrders.length === 1 ? "grid-rows-1" : "grid-rows-2"}  lg:grid-rows-none md:grid-flow-col auto-cols-[minmax(49%,1fr)] lg:grid-cols-1 lg:grid-flow-row lg:auto-rows-min gap-3 lg:overflow-y-auto overflow-y-auto xs:overflow-x-auto pb-5`}>
                    {filteredOrders.map((order, index) => (
                        <Card
                            data={data}
                            key={index}
                            IsSelected={selectedOrder === order}
                            onClick={() => setSelectedOrder(order)}
                            order={order}

                            statuses={miniStatuses(order)}
                            // status={order.status}
                            // InFirst={order.status === 1}
                            // InSecond={order.status === 2}
                            // InThird={order.status === 3}

                            Nactive_bg={data.card_list.Nactive_bg}
                            active_bg={data.card_list.active_bg}
                            title={data.card_list.title}
                            text_gray={data.card_list.text_gray}
                            text_dark={data.card_list.text_dark}
                            text_white={data.card_list.text_white}
                            ID={order._id}
                            status_title={order.statuses.done.length >= 1 ? order.statuses.done[order.statuses.done.length - 1].name : "В процессе"}
                            // TODO: CHANGE BG
                            status_bg={data.card_list.status_bg}
                            status_text={data.card_list.status_text}
                            status_dots={data.card_list.status_dots}
                            status_bar_Nactive={data.card_list.status_bar_Nactive}
                            status_bar={data.card_list.status_bar}
                            status_bar_fill={data.card_list.status_bar_fill}
                            dark_point={data.card_list.dark_point}
                            white_point={data.card_list.white_point}
                            trans_point={data.card_list.trans_point}
                            dots_bar={data.card_list.dots_bar}
                            gray_bar={data.card_list.gray_bar}
                            white_bar={data.card_list.white_bar}
                            // date_1={order.date_1}
                            // date_2={order.date_2}
                            // date_3={order.date_3}
                            // status_1={order.status_1}
                            // status_2={order.status_2}
                            // status_3={order.status_3}
                            // time_1={order.time_1}
                            // time_2={order.time_2}
                            // time_3={order.time_3}
                            empty_time="-:-"
                        />
                    ))}
                </div>
            </div>
            {selectedOrder ? (
                <DopInfo order={selectedOrder} data={data} />
            ) : (
                <span style={{ backgroundColor: "#FFF" }} className="lg:w-[55%] xs:w-[100%] h-full flex xs:text-[60px] text-[40px] justify-center items-center text-center p-8 lg:rounded-[0px] rounded-[20px]">Нет заявок по необходимому фильтру</span>
            )

            }

            {/* {isModalOpen && (
                <Modal
                data={data}
                onClose={closeModal}
                navOpen={navOpen}
                isModalOpen = {isModalOpen}
                />
                
                )} */}
        </div>
    );
};

export default Dostavka;
